var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggiungiBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.571 3.125C7.321 3.125 3.021 7.4 3.021 12.675C3.021 17.95 7.296 22.225 12.571 22.225C17.846 22.225 22.096 17.925 22.096 12.675C22.096 7.425 17.821 3.125 12.571 3.125ZM12.571 20.875C8.046 20.875 4.371 17.2 4.371 12.675C4.371 8.15 8.046 4.475 12.571 4.475C17.096 4.475 20.771 8.15 20.771 12.675C20.771 17.2 17.096 20.875 12.571 20.875Z",
    fill: "url(#paint0_linear_258_354)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8331 11.7306H13.3387V8.09066C13.3387 7.64677 12.9978 7.29166 12.5717 7.29166C12.1456 7.29166 11.8046 7.64677 11.8046 8.09066V11.701H8.36714C7.94101 11.701 7.6001 12.0561 7.6001 12.5C7.6001 12.9439 7.94101 13.299 8.36714 13.299H11.8331V16.9093C11.8331 17.3532 12.174 17.7083 12.6001 17.7083C13.0262 17.7083 13.3671 17.3532 13.3671 16.9093V13.299H16.8331C17.2592 13.299 17.6001 12.9439 17.6001 12.5C17.5717 12.0857 17.2308 11.7306 16.8331 11.7306Z",
    fill: "url(#paint1_linear_258_354)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_354",
    x1: 12.5585,
    y1: 3.125,
    x2: 12.5585,
    y2: 22.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_258_354",
    x1: 12.6001,
    y1: 7.29166,
    x2: 12.6001,
    y2: 17.7083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggiungiBlue);
export default __webpack_public_path__ + "static/media/aggiungi_blue.a4bf81f4710a9eef2aa41766c9878668.svg";
export { ForwardRef as ReactComponent };